import {formDataRequest, getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateHQReport(params) {
    return await formDataRequest('cadres/create', params);
}
export async function serviceUpdateHQReport(params) {
    return await formDataRequest('cadres/update', params);
}

export async function serviceGetHQReport(params) {
    return await postRequest('sales/target/region/report', params);
}

export async function serviceGetHQReportDetails(params) {
    return await postRequest('cadres/detail', params);
}

export async function serviceDeleteHQReport(params) {
    return await formDataRequest('cadres/delete', params);
}
export async function serviceGetHQReportExport(params) {
    return await postRequest('sales/target/region/report/export', params);
}